// extracted by mini-css-extract-plugin
module.exports = {"checkboxInputRow":"l_n6","checkboxInputColumn":"l_n7","inputOptionRow":"l_nY","inputOptionColumn":"l_nZ"};